import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconAdobeSign = ({ className = '', height = 30, title, width = 30 }: Icon) => (
    <AccessibleSVG
        className={`icon-adobe-sign ${className}`}
        height={height}
        title={title}
        viewBox="0 0 30 30"
        width={width}
    >
        <path d="M1.27 1.27h27.45v26.67H1.27z" fill="#260000" />
        <path d="M0 0v29.23h30V0zm1.45 1.45h27.1v26.31H1.45z" fill="#ff3601" />
        <path d="M5.8 11.59v4.01l1.73 2.76 1.72-2.76v-4.01H5.8M5.68 20.4h19.06v1.04H5.68z" fill="#ff3601" />
        <path
            d="M24.78 16a.29.29 0 0 0-.2-.16 8.9 8.9 0 0 0-4.64.45c1.24-1.64 1-1.93.91-2.09s-.38-.22-.72-.08a28.23 28.23 0 0 0-3.07 1.54c1-1.54 1.35-2.55 1.1-2.94a.55.55 0 0 0-.58-.23 7.25 7.25 0 0 0-1.13.29c2.07-3.1 2.72-4.71 2.23-5.54-.23-.38-.7-.54-1.39-.46a8.13 8.13 0 0 0-3.77 1.92 5.38 5.38 0 0 0-2.12 2.84 1.17 1.17 0 0 0 1 1.25.31.31 0 0 0 .25 0 .29.29 0 0 0 .16-.2.29.29 0 0 0 0-.24.29.29 0 0 0-.2-.16c-.49-.15-.54-.38-.53-.57.11-1.3 3.49-3.94 5.32-4.16.4 0 .65 0 .74.16.34.58-.59 2.48-2.77 5.64-2.8 1.29-4.85 3.25-5 4.27a.85.85 0 0 0 .48.92.8.8 0 0 0 .44.11c1.15 0 2.61-2 4.54-4.78a7.77 7.77 0 0 1 1.79-.57 13.36 13.36 0 0 1-1.88 3.33.32.32 0 0 0 0 .42.34.34 0 0 0 .41 0 38.86 38.86 0 0 1 4-2.11 15.55 15.55 0 0 1-1.42 1.94.35.35 0 0 0 0 .41.32.32 0 0 0 .38.11c.58-.23 3.56-1.33 5.29-.82a.31.31 0 0 0 .25 0 .35.35 0 0 0 .16-.2.31.31 0 0 0-.03-.29zm-10.22-1.62c-.93 1.31-2.75 3.83-3.45 3.46-.11-.05-.14-.1-.12-.23.1-.72 1.74-2.19 3.57-3.23z"
            fill="#facfcb"
        />
    </AccessibleSVG>
);

export default IconAdobeSign;
